import { useAppDispatch, useAppSelector } from 'store/hooks';
import { MenuManagerTable } from 'components/menu-manager/MenuManagerTable';
import { MainLayout } from 'layouts/MainLayout';
import React from 'react';
import { getAllLocationTitles } from 'store/locations/locationsSlice';
import { getMenuSummaryList } from 'store/menu-manager/menuManagerSlice';
export const MenuManager = () => {
    const { menuSummaryList, isLoading } = useAppSelector(state => state.menuManager);
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        getMenuSummaryList(dispatch);
        getAllLocationTitles(dispatch);
    }, [dispatch]);

    return (
        <MainLayout
            pageName="Menus"
            pageDescription="View and manage your menus and their associated locations"
            noScroll
        >
            <MenuManagerTable isLoading={isLoading} menuSummaryList={menuSummaryList} />
        </MainLayout>
    );
};
